import { render, staticRenderFns } from "./SpeakingDialogue.vue?vue&type=template&id=917ffa0c&"
import script from "./SpeakingDialogue.vue?vue&type=script&lang=js&"
export * from "./SpeakingDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports